var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.devices != null && _vm.devices.length === 0
      ? _c(
          "div",
          [
            _c(
              "b-row",
              { staticClass: "align-center" },
              [_c("b-col", [_c("i", [_vm._v("Aucune tablette")])])],
              1
            ),
          ],
          1
        )
      : _c(
          "div",
          [
            _vm.full
              ? _c(
                  "b-button",
                  {
                    directives: [
                      {
                        name: "b-toggle",
                        rawName: "v-b-toggle",
                        value: "list-invisible-device",
                        expression: "'list-invisible-device'",
                      },
                    ],
                    staticClass: "m-1",
                    attrs: { variant: "info" },
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "when-open" },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: ["fas", "chevron-up"] },
                        }),
                        _vm._v(" "),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "when-closed" },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: ["fas", "chevron-down"] },
                        }),
                        _vm._v(" "),
                      ],
                      1
                    ),
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.$t("label.list_tablets")) +
                        "\n    "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "b-collapse",
              { attrs: { id: "list-invisible-device", visible: !_vm.full } },
              [
                _c(
                  "b-row",
                  {
                    staticClass: "justify-content-md-center",
                    attrs: { "align-v": "center" },
                  },
                  [
                    _c(
                      "b-col",
                      { attrs: { "align-self": "center" } },
                      [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Filtrer",
                                      "label-cols-sm": "3",
                                      "label-align-sm": "left",
                                      "label-size": "sm",
                                      "label-for": "filterInput",
                                    },
                                  },
                                  [
                                    _c(
                                      "b-input-group",
                                      { attrs: { size: "sm" } },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "filterInput",
                                            type: "search",
                                            placeholder:
                                              "Taper pour rechercher une tablette",
                                          },
                                          model: {
                                            value: _vm.filter,
                                            callback: function ($$v) {
                                              _vm.filter = $$v
                                            },
                                            expression: "filter",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "b-input-group-append",
                                          [
                                            _c(
                                              "b-button",
                                              {
                                                attrs: {
                                                  disabled: !_vm.filter,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    _vm.filter = ""
                                                  },
                                                },
                                              },
                                              [_vm._v("Effacer")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("b-table", {
                          attrs: {
                            fields: _vm.fields,
                            items: _vm.devices,
                            filter: _vm.filter,
                            "filter-included-fields": _vm.filterOn,
                            small: "",
                            responsive: "sm",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "cell(dev_serial)",
                              fn: function (row) {
                                return [
                                  _c("b-col", [
                                    _vm._v(_vm._s(row.item.dev_serial)),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell(dev_appversion)",
                              fn: function (row) {
                                return [
                                  _c("b-col", [
                                    _vm._v(
                                      _vm._s(
                                        row.item.dev_meta?.app_version ||
                                          row.item.dev_appversion
                                      )
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell(dev_last_synchro)",
                              fn: function (row) {
                                return [
                                  _c("b-col", [
                                    _vm._v(_vm._s(row.item.dev_last_synchro)),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell(dev_access)",
                              fn: function (row) {
                                return [
                                  _c("b-col", [
                                    _vm._v(_vm._s(row.item.dev_access)),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell(dev_state)",
                              fn: function (row) {
                                return [
                                  _c(
                                    "b-col",
                                    [
                                      row.item.dev_state
                                        ? _c(
                                            "b-badge",
                                            { attrs: { variant: "success" } },
                                            [_vm._v("Connecté")]
                                          )
                                        : _c(
                                            "b-badge",
                                            { attrs: { variant: "danger" } },
                                            [_vm._v("Déconnecté")]
                                          ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                            {
                              key: "cell(update)",
                              fn: function (row) {
                                return [
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        [
                                          !_vm.full
                                            ? _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "outline-warning",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.$emit(
                                                        "fix",
                                                        row.item
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Dépanner")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.full && row.item.dev_state
                                            ? _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "danger",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.disconnect(
                                                        row.item
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Déconnecter")]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }